import { ReactNode, useMemo, useState } from 'react';
import { ProviderFactory } from 'shared/providers/provider-factory';

type MultiDayShiftHoverContextValue = {
  hoveredMultiDayShiftId: string | null;
  setHoveredMultiDayShiftId: (multiDayShiftId: string | null) => void;
};

const [Provider, useMultiDayShiftHoverProvider] = ProviderFactory<MultiDayShiftHoverContextValue>(
  'MultiDayShiftHoverContext can only be accessed within MultiDayShiftHoverProvider'
);

export const MultiDayShiftHoverProvider = ({ children }: { children: ReactNode }) => {
  const [hoveredMultiDayShiftId, setHoveredMultiDayShiftId] = useState<string | null>(null);
  const value = useMemo(
    () => ({ hoveredMultiDayShiftId, setHoveredMultiDayShiftId }),
    [hoveredMultiDayShiftId]
  );

  return <Provider value={value}>{children}</Provider>;
};

export const useMultiDayShiftHover = (): MultiDayShiftHoverContextValue => {
  try {
    return useMultiDayShiftHoverProvider();
  } catch {
    return {
      hoveredMultiDayShiftId: null,
      setHoveredMultiDayShiftId: () => undefined,
    };
  }
};
